import moment from 'moment';

import { CLIENT_APP_URL } from '../../../../../env';

const loadDetailUrl = `${CLIENT_APP_URL}loads/detail/`;

/**
 * Validates a given payload from the form
 * @param {object} load - Selected Load
 * @param {object} comments - Comments for bounced load
 * @return {string}
 */
export function getBounceEmailBody(load, comments, reason) {
  return (
    `Carrier Rep: ${load.carrierRepName || ''}
Carrier Name: ${load?.carrierName}
Customer: ${load?.customerName}
Reason: ${reason}
Comments: ${comments}
Bounced At: ${moment(Date.now()).format('M/D/Y h:mmA')}

Pick-Up Information
Address: ${load?.shipmentInformation?.origin?.address?.address1}
City, St. Zip: ${load?.shipmentInformation?.origin?.address?.city}, ${load?.shipmentInformation?.origin?.address?.state}, ${load?.shipmentInformation?.origin?.address?.postalCode} 
Appt Early: ${moment(new Date(load?.shipmentInformation?.origin?.appointmentStart)).utc().format('M/D/Y HH:mm')}
Appt Late: ${moment(new Date(load?.shipmentInformation?.origin?.appointmentEnd)).utc().format('M/D/Y HH:mm')}

Delivery Information
Address: ${load?.shipmentInformation?.destination?.address?.address1}
City, St. Zip: ${load?.shipmentInformation?.destination?.address?.city}, ${load?.shipmentInformation?.destination?.address?.state}, ${load?.shipmentInformation?.destination?.address?.postalCode}
Appt Early: ${moment(new Date(load?.shipmentInformation?.destination?.appointmentStart)).utc().format('M/D/Y HH:mm')}
Appt Late: ${moment(new Date(load?.shipmentInformation?.destination?.appointmentEnd)).utc().format('M/D/Y HH:mm')}

Load Info
Miles: ${load?.miles || ''}
Weight: ${load?.driverInformation?.weight} ${load?.driverInformation?.weightUnit}
Stops: ${(load?.shipmentInformation?.inBetweenStops)?.length + 2}
Total: $${load?.total ? (load?.total).toFixed(2) : ''}`);
}

/**
 * Validates a given payload from the form
 * @param {object} load - Selected Load
 * @param {object} comments - Comments for bounced load
 * @return {string}
 */
// TODO: change hardcoded values on API integration TT-1400
export function getLumperEmailBody(load, comments, lumperFee) {
  return (
    `Load ID#: ${load?.billOfLadingNumber}
Lane: ${load.originState}-${load.destinationState}
Customer: ${load?.customerName}
Carrier: ${load?.carrierName}
Carrier Rep: ${load?.carrierRepName || ''}
Added Charge: $${lumperFee}
Description: Lumper
Notes: ${comments}
Total Order Lumper Charge: $${lumperFee}`
  );
}

export function getProblemEmailBody(load, problem, comments, userName) {
  return (
    `Load #${load?.billOfLadingNumber}
Lane: ${load.originState}-${load.destinationState}
Customer: ${load?.customerName}
Carrier: ${load?.carrierName}
Carrier Rep: ${load.carrierRepName || ''}
Problem: ${problem}
Problem Details: ${comments}
Entered by ${userName}
Do Not Reply to this email - update the problem in Track and Trace on the load.`
  );
}

export function getResolvedProblemEmailBody(load, problem, comments, userName) {
  return (
    `Load #${load?.billOfLadingNumber}
Lane: ${load.originState}-${load.destinationState}
Customer: ${load?.customerName}
Carrier: ${load?.carrierName}
Carrier Rep: ${load.carrierRepName || ''}
    
Problem: ${problem} - *RESOLVED*
Notes: ${comments}
Entered by ${userName}
Do Not Reply to this email - update the problem in Track and Trace on the load. `
  );
}

export function getLoadIdHyperlink(loadId, billOfLadingNumber) {
  return `Load ID#: <a href="${loadDetailUrl}${loadId}">${billOfLadingNumber}</a><br>`;
}
